export default "__VITE_ASSET__0687f9a0__"